import { CadFeatureMap } from '@mark43/cad-api';
import { useRef } from 'react';
import { useBroadcast } from '../common/broadcast-channel/use-broadcast';
import { EnabledFeaturesBroadcast } from '../common/hooks/enabled-features/enabled-features-provider';

export const useEnabledFeaturesBroadcast = (): EnabledFeaturesBroadcast => {
    const setEnabledFeaturesRef = useRef<
        (value: React.SetStateAction<CadFeatureMap | undefined>) => void
    >();

    const { postMessage } = useBroadcast('legacy-store-broadcast', (message) => {
        if (message.type === 'REFRESH_ENABLED_FEATURES') {
            setEnabledFeaturesRef.current?.(message.payload);
        }
    });

    const postRefreshEnabledFeaturesMessage = (enabledFeatures: CadFeatureMap) => {
        postMessage({
            type: 'REFRESH_ENABLED_FEATURES',
            payload: enabledFeatures,
        });
    };

    return { setEnabledFeaturesRef, postRefreshEnabledFeaturesMessage };
};
